import React from "react";
import MultiSelectDropdown from "../../../../../components/multiSelectDropdown/multiSelectDropdown";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/membershipBreakdownSaga";

const StatusTypes = () => {
  const dispatch = useDispatch();

  const { statusTypesOptions, selectedStatusTypes } = useSelector(
    (state) => state.membershipBreakdown
  );

  return (
    <MultiSelectDropdown
      options={statusTypesOptions}
      selectedFilters={selectedStatusTypes}
      includeFilter={false}
      numberDisplayed={1}
      multiple={false}
      keepOpen={false}
      onSelectChange={(data) => {
        if (data.id === selectedStatusTypes.id) return;
        dispatch(actionCreators.updateStatusTypes(data));
      }}
    />
  );
};

export default StatusTypes;
